/**
 * Nueva campaña (`/activa/campanas/nueva`): elegir qué tipo de campaña armar y seguir en el asistente que ya existe. Es
 * el único punto de entrada: llevan acá el «Nueva campaña» del menú y el de la lista de Campañas (pedido del 28/10/2026).
 * Cada opción dice cuándo conviene. Debajo, «Empezar de una anterior» (29/10/2026): duplica una del WhatsApp oficial y
 * abre la copia en su asistente (`EmpezarDeUnaAnterior`).
 * Del equipo: App.tsx la envuelve en `PaginaSoloEquipo`, como a cada asistente.
 */

import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { EncabezadoPagina, Pagina } from "../../../components/activa/Pagina";
import { MUNDO, OPCIONES_NUEVA, R_CAMPANAS, TEXTO_NUEVA_MAIL } from "../logic/campanas";
import { EmpezarDeUnaAnterior } from "../../wa-oficial/components/EmpezarDeUnaAnterior";

export default function NuevaCampanaPage() {
  return (
    <Pagina angosta>
      <EncabezadoPagina antetitulo="Campañas" titulo="Nueva campaña" bajada="Elegí qué campaña querés armar: cada una sigue en su asistente." />
      <ul className="grid gap-3 sm:grid-cols-2" aria-label="Tipos de campaña">
        {OPCIONES_NUEVA.map((o) => (
          <li key={o.id} className="min-w-0">
            <Link
              to={o.ruta}
              data-testid={`nueva-${o.id}`}
              className="group flex h-full flex-col gap-2 rounded-2xl border border-slate-200 bg-white p-4 hover:border-violet-300 hover:bg-violet-50/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400"
            >
              <span className={`self-start rounded-full px-2 py-0.5 text-[11px] font-semibold ${MUNDO[o.mundo].cls}`}>{MUNDO[o.mundo].label}</span>
              <span className="text-base font-semibold text-slate-900">{o.titulo}</span>
              <span className="text-sm text-slate-600 break-words">{o.texto}</span>
              <span className="text-sm font-medium text-slate-800 break-words" data-testid={`conviene-${o.id}`}>{o.conviene}</span>
              <span className="mt-auto inline-flex items-center gap-1 pt-1 text-sm font-semibold text-violet-700">
                Empezar
                <ArrowRight size={14} aria-hidden="true" className="transition-transform group-hover:translate-x-0.5" />
              </span>
            </Link>
          </li>
        ))}
      </ul>
      <EmpezarDeUnaAnterior />
      <p className="text-sm text-slate-500">{TEXTO_NUEVA_MAIL}</p>
      <Link to={R_CAMPANAS} className="inline-flex min-h-[44px] items-center gap-2 text-sm font-semibold text-violet-700 hover:text-violet-900">
        <ArrowLeft size={16} aria-hidden="true" />
        Volver a Campañas
      </Link>
    </Pagina>
  );
}
